<template>
  <LogComponent />
</template>

<script>
import LogComponent from '@pages/supplier/prod/log/index.vue';

export default {
  components: {
    LogComponent,
  },
};
</script>
